import { render, staticRenderFns } from "./UsageDetails.vue?vue&type=template&id=3c9b40aa&scoped=true"
import script from "./UsageDetails.vue?vue&type=script&lang=js"
export * from "./UsageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b40aa",
  null
  
)

export default component.exports